<template>

  <span>

    <div :class="{'analysis-credits':true,show: showIt}">
      <span class="credits">{{analysisCredits}}</span>
      <span :class="{analysis:true,hasLink:!!action.label}">Analysis credit{{creditS}}<span class="inline"><br><span class="play" @click="goAnalysis" v-html="action.label" v-if="action.label" /></span></span>
    </div>

    <AnalysisCreditsOops
			v-if="showOops"
			@close="closeOops"
		/>

    <AnalysisCreditsHow
			v-if="showHow"
			@close="closeHow"
		/>

  </span>

</template>

<script>
import { mapMutations, mapState } from 'vuex'
import ApiService from './../services/api.service'
import general from './../utils/general'
import AnalysisCreditsOops from './KeywordDomainAnalysis/AnalysisCreditsOops.vue'
import AnalysisCreditsHow from './KeywordDomainAnalysis/AnalysisCreditsHow.vue'
export default {
	name: 'AnalysisCredits',
	components: {
    AnalysisCreditsOops,
    AnalysisCreditsHow
  },
	props: {},
	data() {

		return {
			loaded: false,
			showOops: false,
      showHow: false,
      show: true
		}

	},
	watch:{
		reload (){
      
			if ( this.reload ) {

				this.checkAllowed();

			}

		},
    showAnalysisCreditsHow (){

			if ( this.showAnalysisCreditsHow ) {

				this.showTheHow();

        this.updateVar( {varName:'showAnalysisCreditsHow', info:false} ); 

			}

		},
    buyAnalysisCredits () {

      if ( this.buyAnalysisCredits ) {

        this.updateVar( {varName:'buyAnalysisCredits', info:false} ); 
				this.goAnalysis (true);

			}

    },
    $route: {
      immediate: true,
      deep: true,
      handler( to ) {
        
        this.show = false;

        if ( !to.name ) return;
      
        ['content-and-keyword','website-analysis'].forEach ( function (n) {
          
          if ( to.name.indexOf(n) > -1 ) this.show = this.onAnalysisPages;

        }.bind(this));

      }
    }
	},
	computed: { 
		...mapState('general',['analysisCredits','reloadAnalysisCredits','buyAnalysisCredits','showAnalysisCreditsHow','analysisCreditsAllowed','analysisCreditsAccess']),

    showIt() {

      return ( this.analysisCreditsAllowed && this.loaded && this.show && !this.readOnly );

    },

    readOnly () {

      return this.analysisCreditsAccess.shared && this.analysisCreditsAccess.readOnly;

    },

    reload () {

      return this.reloadAnalysisCredits;

    },

    onAnalysisPages () {

      let is = false;

      ['content-and-keyword','website-analysis'].forEach ( function (n) {

          if ( !!this.$route.name && this.$route.name.indexOf(n) > -1 ) is = true;

      }.bind(this));

      return is;

    },

    action () {

      let buy = true, label = 'Buy more / Info';

      if ( !this.shouldBuyMore ) {

        buy = false;
        label = 'Have a play';

      }

      if ( this.analysisCreditsAccess.shared ) label = '';

      return { buy, label };

    },
    creditS () {

      return this.analysisCredits == 1 ? '' : 's';

    },
    shouldBuyMore () {

      return this.analysisCredits < 10 || this.onAnalysisPages;

    }
  },
	mounted() {

		this.checkAllowed(true);

	},

	methods: {

		...mapMutations('general',['updateVar']),

    closeHow () {

			this.showHow = false;

			general.modalClose();

		},

    showTheHow () {

			this.showHow = true;

		},

    closeOops () {

			this.showOops = false;

			general.modalClose();

		},

		goAnalysis (buy) {

      if ( this.action.buy || ( buy && buy === true ) ) {

        this.showOops = true;

      }
      else {

			  this.$router.push({ path: '/content-and-keywords' });

      }

		},

    checkAllowed (first) {

      ApiService.get( 'googlea/access' )
      .then( function(info) {

        this.updateVar( { varName: 'analysisCreditsAccess', info: info.data } ); 

        let ok = false;
        
        Object.keys(info.data).forEach ( function (t) {

          if ( t === 'costs' || t === 'trial' ) return;

          if ( this.analysisCreditsAccess[t] ) ok = true;

        }.bind(this));

        this.updateVar( { varName: 'analysisCreditsAllowed', info: ok } ); 

        this.loadCredits(first);

      }.bind(this))
      .catch( function(err) {
        console.log(err);
      }.bind(this));

    },

		loadCredits(first) {

      if ( !this.analysisCreditsAllowed ) {

        this.updateVar( { varName: 'analysisCreditsInfo', info: this.analysisCreditsAccess } );
        this.updateVar( { varName: 'analysisCreditsInfoLoaded', info: true } ); 
        this.updateVar( {varName:'reloadAnalysisCredits', info:false} ); 
        
        return;

      }
      
	    ApiService.get( 'googlea/analysis-credits' )
			.then( function( info ) {

				this.updateVar( {varName:'reloadAnalysisCredits', info:false} ); 

				setTimeout( function () { 

					this.updateVar( { varName: 'analysisCredits', info:info.data.all } ); 
          this.updateVar( { varName: 'analysisCreditsInfo', info:info.data } );
          this.updateVar( { varName: 'analysisCreditsInfoLoaded', info: true } ); 

					this.loaded = true;

				}.bind(this), first ? 2000 : 1 );

			}.bind(this))
			.catch( function(err) {

			}.bind(this));

	    }

	}
}
</script>

<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';
.analysis-credits {
  background-color: @formDefaultColour;
  color: #fff;
  position: fixed;
  right: 110px;
  bottom: -100px;
  z-index: 5;
  border-radius: 5px 5px 0 0;
  font-size: 12px;
  padding: 5px 10px 8px;
  overflow: hidden;
  .trans;
  &.show {
    bottom: 0;
  }
  span {
    color: inherit;
    font-size: inherit;
    display: inline-block;
    text-align: center;
    vertical-align: top;
    &.inline {
      display: inline;
    }
    &.analysis {
      padding-left: 5px;
      font-weight: @bold;
      padding-top: 23px;
      &.hasLink {
        padding-top: 14px;
      }
    }
    &.play {
      cursor: pointer;
      font-weight: normal;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
    &.credits {
      background-color: #fff;
      color: @formDefaultColour;
      border-radius: 5px;
      font-size: 1.8em;
      position: relative;
      margin-top: 15px;
      padding: 2px 6px;
      &:before {
        content:"You have";
        font-size: 0.4em;
        position: absolute;
        width: 200%;
        left: -50%;
        text-align: center;
        top: -15px;
        color: #fff;
      }
    }
    &.play {

    }
  }
}
</style>